export default "__VITE_ASSET__UVSZ5ku4__"